import request from 'lib/request'
import axios from 'lib/request/axios'

const api = {
  fetch: (meta) => request.get(`api/gifticons`, meta),
  update: (gifticonCode, active) =>
    request.put(`api/gifticons/${gifticonCode}`, { active: active }),
  sync: () => request.get(`api/gifticons/updateGoods`),
}

export default api
